// extracted by mini-css-extract-plugin
export default {"button":"listScreenActionMenu_button__23pZy","actionLabel":"listScreenActionMenu_actionLabel__cAHBR","addIcon":"listScreenActionMenu_addIcon__JE1tM"};